import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { TextField, Button } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useEditorContext } from "../EditorContext";
import { Block } from "./blockType";
import { breadcrumbBlockDataSchema } from "./blockDataSchema";
import { z } from "zod";
import { loremIpsum } from "../utils/loremipsum";
import EditTitle from "../components/EditTitle";
import { Label } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import Link from "../components/Link";
import LinkName from "../components/LinkName";


const id = "breadcrumb" as const;
const name = "Breadcrumb" as const;

type BreadcrumbDataBlock = z.infer<typeof breadcrumbBlockDataSchema>;

const isDataBlock = (block: unknown): block is BreadcrumbDataBlock =>
  breadcrumbBlockDataSchema.safeParse(block).success;

const Component: React.FC<BreadcrumbDataBlock> = (block) => {
  const location = useLocation();
  return (
    <Typography
      component="p"
      variant="body1"
      sx={{
        color: "gray",
      }}
    >
      {location.pathname.split("/").map((path, index, arr) => {
        if (path === "") return null;
        return (
          <>
            {" / "}
            <span key={index}>
              {(index === arr.length - 1) ? 
                (
                  <strong
                    style={{
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    <LinkName path={arr.slice(0, index + 1).join("/")} />
                  </strong>
                ) : (
                  <Link to={arr.slice(0, index + 1).join("/")}>
                    <LinkName path={arr.slice(0, index + 1).join("/")} />
                  </Link>
                )
              }

            </span>
          </>
        );
      })}
    </Typography>
  );
};

const ListComponent: React.FC<BreadcrumbDataBlock> = (block) => {
  return (
    <>
      <Box
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        <strong>Breadcrumb</strong>
      </Box>
    </>
  );
};

const EditComponent: React.FC<BreadcrumbDataBlock> = (block) => {
  const { setWorkInProgress } = useEditorContext();

  return (
    <>
      <EditTitle>Breadcrumb</EditTitle>
    </>
  );
};

const initialBlock: () => Omit<
  BreadcrumbDataBlock,
  "blockId" | "endpoint"
> = () => ({
  blockType: "breadcrumb" as const,
});

const block: Block<BreadcrumbDataBlock> = {
  id,
  name,
  isDataBlock: isDataBlock,
  Component,
  ListComponent,
  EditComponent,
  initialBlock,
};

export default block;
